interface InterstitialType { link:string, title:string, body:string }

const Interstitial = ({ link, body, title }:InterstitialType) => {
    return <div className="fb-interstitial local-condition">
        <h2>{title}</h2>
        <p className="copied-friendly-message">
            {body}
        </p>
        {/*<div className="pro-tip">*/}
        {/*    <div className="pro-tip-header">*/}
        {/*        <div className="pro-tip-header-text">*/}
        {/*            <span>Pro Tip</span>*/}
        {/*            <h4>Share your project in local community groups</h4>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*    <p>*/}
        {/*        Along with sharing with your friends and family, try posting your project in a local community group. Teachers like you have found support from their community by searching for local city, town, or neighborhood groups and sharing with neighbors there.*/}
        {/*    </p>*/}
        {/*</div>*/}
        <div className="fb-not-open-link">
            Facebook not opening? <a href={link} target="_blank" rel='noreferrer'>Click here</a>
        </div>
    </div>;
};

export default Interstitial;
